import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {Chart} from 'angular-highcharts';
import {IntelligenceData} from '../../../models/intelligence-data.interface';
import {INTELLIGENCE_PIE_COLORS} from '../../../../constants/charts';
import {PointOptionsObject} from 'highcharts';
import {MessageService} from '../../../../shared/services/message.service';
import {Router} from '@angular/router';
import {AuthService} from '../../../../core/services/auth.service';

@Component({
  selector: 'app-collection-points-operated-pie-chart',
  templateUrl: './collection-points-operated-pie-chart.component.html',
  styleUrls: ['./collection-points-operated-pie-chart.component.scss']
})
export class CollectionPointsOperatedPieChartComponent implements OnInit, OnChanges {

  textBelow!: string;
  chart!: Chart;
  chartData!: any[];
  pieCategories!: string[];
  textBelowCode = 'intelligence.WeeeSystem.CollectionPointsOperated.textBelow';
  isAdmin!: boolean;

  @Input()
  data!: IntelligenceData[];
  @Input()
  displayUnits!: string;
  @Input()
  title!: string;
  @Input()
  subtitle!: string;

  private static getPieCategories(chartData: IntelligenceData[]): string[] {
    const pieCategories: string[] = [];
    chartData.forEach(item => {
     if (Number(item.answer) < 500) {
       pieCategories.push('<500');
     }
     else if (Number(item.answer) >= 500 && Number(item.answer) < 1000) {
        pieCategories.push('501 to 1.000');
     }
     else if (Number(item.answer) >= 1000 && Number(item.answer) < 3000) {
       pieCategories.push('1.001 to 3.000');
     }
     else if (Number(item.answer) >= 3000 && Number(item.answer) < 5000) {
       pieCategories.push('3.001 to 5.000');
     }
     else if (Number(item.answer) >= 5000 && Number(item.answer) < 10000) {
       pieCategories.push('5.001 to 10.000');
     }
     else {
       pieCategories.push('>10.001');
     }
    });
    return pieCategories;
  }

  constructor(private readonly messageService: MessageService,
              private readonly router: Router,
              private authService: AuthService) {
  }

  ngOnInit(): void {
    this.isAdmin = this.authService.getUserRoles().includes('WF_ADMIN');
    this.messageService.getDialogInfo(this.textBelowCode).subscribe((data) => {
      if (data !== null) {
        this.textBelow = data.description;
      }
    });
  }

  ngOnChanges(): void {
    if (this.data) {
      this.pieCategories = CollectionPointsOperatedPieChartComponent.getPieCategories(this.data);
      this.chartData = this.convertToChartData();
      this.chart = new Chart({
        chart: {
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        colors: INTELLIGENCE_PIE_COLORS,
        title: {
          text: this.title
        },
        subtitle: {
          text: this.subtitle
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: true,
              format: '{point.name}'
            }
          }
        },
        exporting: {
          enabled: true
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        tooltip: {
          formatter(): string[]|undefined {
            if (this.point.name) {
              const pointOptions = this.point as PointOptionsObject;
              if (pointOptions.custom?.absolute === 0) {
                return [this.point.name];
              }
              return ['<div class="center"><b>' + this.point.name + '</b></div><br><br>',
                '- Total responses: ' + pointOptions.custom?.totalResponses + '<br>',
                '- Total sum of facilities: ' + pointOptions.custom?.totalSum + '<br>',
                '- Average: ' +  pointOptions.custom?.average.toFixed(0)
              ];
            }
            // If not null, use the default formatter
            // return tooltip.defaultFormatter.call(this, tooltip);
            return undefined;
          }
        },
        series: [{
          name: 'Value (%)',
          type: 'pie',
          data: this.chartData
        }]
      });
    }
  }

  editTextBelow(): void {
    this.router.navigate(['/admin/chart-labels'], {state: { code: this.textBelowCode }}).then(
      () => {
        // do nothing
      }
    );
  }

  private convertToChartData(): any[] {
    this.chart?.ref?.hideData();
    const chartData: any[] = [] ;
    this.data.forEach((item, index) => {
      if (item.totalResponses > 0) {
        chartData.push({
          y: Number(((item.totalResponses / item.totalAdditionResponses) * 100).toFixed(2)),
          name: this.pieCategories[index],
          custom: {
            totalResponses: item.totalResponses,
            totalSum: item.totalSum,
            average: item.totalSum / item.totalResponses,
          }
        });
      }
    });
    return chartData;
  }

}
